export default __webpack_public_path__ + "static/media/background.2465d80f.jpeg";